module.exports = __webpack_public_path__ + "img/9877c9ef99079da0327701bf36043128.882b5282.jpg";